import { Button, FormControl, InputLabel, makeStyles, MenuItem, Select, Typography } from "@material-ui/core";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import React, { useEffect, useState, useReducer } from "react";
import translate from "../../../i18n/translate";
import "./CultureNotesLocation.scss";
import RollbarErrorTracking from "../../../utils/RollbarErrorTracking";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import { useHistory, useLocation } from "react-router-dom";
import ReactGA from "react-ga";
import Axios from "axios";
import Loader from "../../shared/Loader/Loader";
import { useSelector } from "react-redux";
import { countryListCode, countriesList } from "../../../globalConstants";

const CultureNotesLocation: React.FC = () => {
    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 250,
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
        },
    }));

    const [iscultureNotesLocationfeatureenabled, setCultureNotesLocationfeatureenabled] = useState(false);
    const [iscultureNotesLocationerrorenabled, setCultureNotesLocationerrorenabled] = useState(false);
    const [islocation, setLocation] = useState<any>();
    const [isselectLocationDisabled, setSelectLocationDisabled] = useState(true);
    const [isselecttopicDisabled, setSelecttopicDisabled] = useState(false);
    const [isbody, setBody] = useState<any>();
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedCountry, setSelectedCountry] = useState<string>('');
    const classes = useStyles();
    const GALocation = useLocation();
    const history = useHistory();
    const allInfo = useSelector((state: any) => state);

    let [topic, setTopic] = useState("");
    let [loaderFlag, setLoaderFlag] = useState(false);

    const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
        toastOpen: false,
        toastSeverity: "error",
        toastMessageKey: "",
      });
    
      const handleToastOptionsDirect = (name: string, val: any) => {
        settoastOptions({ [name]: val });
      }
    
      const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
        handleToastOptionsDirect("toastSeverity", severity);
        handleToastOptionsDirect("toastMessageKey", messageKey);
        handleToastOptionsDirect("toastOpen", !!open);
      };

    useEffect(() => {
        if (!!!allInfo.peopleInformation.isLoading && !!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
            if ((allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(27, 28)) === "1") {
                setCultureNotesLocationfeatureenabled(true);
                setCultureNotesLocationerrorenabled(false);
            } else {
                setCultureNotesLocationfeatureenabled(false);
                setCultureNotesLocationerrorenabled(true);
                setLoaderFlag(false);
            }
            initGoogleAnalytics();
        }
    }, [allInfo.peopleInformation, GALocation]);

    useEffect(() => {
        if(!!!allInfo.peopleInformation.isLoading && !!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data){
            initGoogleAnalytics();
        }
    }, [isbody]);

    async function fetchCultureNotesData(countrySelected: string) {
        setLoaderFlag(true);
        let countryCode: any = countryListCode.find(x => x.key === (countrySelected ? countrySelected : "Germany"));
        const data = await Axios.get(`${process.env.REACT_APP_OSCAR_URL}/content/test/culture_centre/${countryCode.val}/default.json`).then((response) => {
            return response.data;
        }) .catch((err: any) => {
            setLoaderFlag(false);
            toasterHandle(true, "error", "message_errorDefault");
            RollbarErrorTracking.logErrorInRollbar(err.message, "error");
        });
        return data;        
    }

    const handleCountryChange = async(event: any, isEvent: boolean) => {
        const inputValue: string = isEvent ? event.target.value : allInfo.common.selectedCountry;
        const localeData: any = await fetchCultureNotesData(inputValue);        
        setLocation(localeData);
        setSelectedCountry(localeData.title);
        setSelecttopicDisabled(false);
        setCurrentPage(0);
        handleTopicChange("", false, localeData.content[0].title, localeData);
    };

    const handleTopicChange = (event: any, isEvent: boolean, selectionValue: string, localeData: any) => {
        const inputValue = isEvent ? event.target.value : selectionValue;
        const filterData: any = isEvent ? islocation : localeData;
        let article = filterData.content.filter((data: any) => data.title === inputValue);
        if(isEvent) {
            let getIndex = filterData.content.findIndex((x: any) => x.title === event.target.value);
            setCurrentPage(getIndex);
        }
        setTopic(inputValue);
        setBody(article[0]);
    }

    const nextClick = () => {
        if (currentPage < islocation.content.length) {
            let nextarticlesList = islocation.content.filter((data: any) => data.title === islocation.content[currentPage + 1].title);
            setBody(islocation.content[currentPage + 1]);
            setTopic(nextarticlesList[0].title);
            setCurrentPage(currentPage + 1);
        }
    }

    const prevClick = () => {
        if (currentPage !== 0) {
            let prevArticlesList = islocation.content.filter((data: any) => data.title === islocation.content[currentPage - 1].title);
            setBody(islocation.content[currentPage - 1]);
            setTopic(prevArticlesList[0].title);
            setCurrentPage(currentPage - 1);
        }
    }

    const pdf_download = (option: any) => window.open(option);
    const redirecttocultureNotes = () => history.push("/culturenotes");

    const initGoogleAnalytics = () => {
        if ((allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(84, 85)) === "1") {
            const trackingId: string = process.env.REACT_APP_GA_TRACKING_ID || "";
            ReactGA.initialize(trackingId);
            const culturepath  = `${selectedCountry +'/'+ isbody?.title}`;
            const url = window.location.pathname + '/' + culturepath;
            ReactGA.set({ page: url });
            ReactGA.pageview(url);
        }
    };

    useEffect(() => {
        setLoaderFlag(true);
        setSelectedCountry(allInfo.common.selectedCountry);
        setSelectLocationDisabled(false);
        handleCountryChange("", false);
    }, [allInfo.peopleInformation]);

    function htmlDecode(input: string) {
        var doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent || "";
    }
   
    return (
        <span className="cultureNotes-Location-Container">
        {iscultureNotesLocationfeatureenabled && 
        <div className="cultureNotes-Location-Childcontainer">          
            <div className="cultureLocation-child-header">
                <div className="CN-Title">
                    <h3 className="cultureLocation-header-text" onClick={redirecttocultureNotes}>
                        {translate("feature_cultureNotes_title")}
                    </h3>
                </div>
            </div>
            <div className="body-Location">
                <div className="child-Location">
                    <div className="CNcountry-Location" >
                        <FormControl variant="outlined" className={classes.formControl} disabled={isselectLocationDisabled}>
                            <InputLabel id="demo-simple-select-outlined-label-location">{translate("SAL")}</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label-location"
                                id="Countries"
                                value={selectedCountry}
                                onChange={(event) => handleCountryChange(event, true)}
                                label={translate("SAL")}
                            >
                                {countriesList.map((option: any, index: number) => {
                                    return (
                                        <MenuItem value={option}>
                                            {translate(option)}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </div>

                    <div className="CNcountry-Location">
                        <FormControl variant="outlined" className={classes.formControl} disabled={isselecttopicDisabled} >
                            <InputLabel id="demo-simple-select-outlined-label-country-location">{translate("SAT")}</InputLabel>
                            {islocation && 
                                <Select
                                    labelId="demo-simple-select-outlined-label-country-location"
                                    id="Topics"
                                    value={topic ? topic : islocation?.content[0].title}
                                    onChange={(event) => handleTopicChange(event, true, "", "")}
                                    label={translate("SAT")}
                                >
                                    {islocation ? islocation.content.map((option: any, index: number) => {
                                            return (
                                                <MenuItem value={option.title}>
                                                    {option.title}
                                                </MenuItem>
                                            );
                                        })
                                        : ""
                                    }
                                </Select>
                            }
                        </FormControl>
                    </div>
                </div>
            </div>
            {islocation && (
                <React.Fragment>
                <div className="cultureNotes-Location-header">
                    <div className="cultureNotes-Location-child-header">
                    <div className="cultureNotes-border-align">
                        <div>
                            <img src={islocation.meta.image} alt="culture_notes" className="CNLocation_header_img" onLoad={() => setLoaderFlag(false)}/>
                        </div>
                        <div className="cultureNotes-CountryName">
                            <span>
                                <img src={islocation.meta.flag} alt="culture_notes" className="CNLocation_flag_img" />
                            </span>
                            {/* <span className="CNdownload-img" onClick={() => pdf_download(process.env.REACT_APP_CN_BLOBSTORAGE + (islocation.meta.Pdf))}>
                                <GetAppOutlinedIcon />
                            </span> */}
                        </div>
                    </div>
                    <div className="CNblock-Heading">
                        <h2 className="CNblock-headertext">{islocation.title}</h2>
                    </div>
                  
                    {isbody &&
                        <React.Fragment>
                            <div className="content-Container">
                                <h2 className="CNbody-header">{isbody.title}</h2>
                                <div className="content-image">
                                    <img src={isbody ? isbody.image : ""} alt="flag" className="CN-image" />
                                </div>
                                <div className="CNPara-align">
                                    <span dangerouslySetInnerHTML={{ __html: htmlDecode(isbody.description) }} />
                                </div>                               
                            </div>
                            </React.Fragment>
                            }                          
                    </div>                                    
                    {isbody &&
                            <React.Fragment>
                            <div className="CNPagination">
                                <span>
                                    {currentPage + 1}/{islocation.content.length}
                                </span>
                                <span className="arrowbtn" onClick={prevClick}>
                                    <ArrowBackIosIcon></ArrowBackIosIcon>
                                </span>
                                <Button type="button" variant="contained" color="primary" onClick={nextClick} 
                                disabled={currentPage === (islocation.content.length - 1)} 
                                >
                                    <Typography>{translate("button_next")}</Typography>
                                </Button>
                            </div>
                        </React.Fragment>
                        }
                    </div>                   
                </React.Fragment>
            )}
        </div>
        }
         {iscultureNotesLocationerrorenabled && (
            <div className="culture-Notes-Location-Errorpage">
            <ErrorPage status={401} />
            </div>
        )}   
         <Loader showLoader={loaderFlag} /> 
        </span>
    );
}

export default CultureNotesLocation;